const ContactZhCN = {
    contact: "联络",
    address: "地址：4/601 Little Collins Street, Melbourne Vic 3000",
    phone: "电话：+61 03 9833 4890",
    abn: "ABN：47 614 393 903",
    email: `电邮：<a href='mailto:sales@blueshine.com.au'>sales@blueshine.com.au</a>`,
}

export default ContactZhCN;